import {concat, emptyArray} from '@packages/utilities/fp/utils';
import {Component, Expressions} from '@packages/systems/wfdl';
import {getPluginName} from '@packages/systems/wfdl-Qualified';
import {Expression, ExpressionElement} from '@packages/systems/wfdl-ast';

// NOTE: The plugin/has check is duplicated from `isUserComponentInst` in
// `@packages/utilities/platform` instead of being imported from there.
// Importing the helper would put this file in a circular dependency with
// the platform package (platform/ElementTreeUtils.ts already imports from
// `@packages/systems/user-components/utils`). Keeping the check inline
// avoids that file-level cycle and is the whole reason this getter was
// extracted into its own file in the first place.
export function buildComponentInstancesGetter(
  componentMap: Component.ComponentMap
): (root: Expression) => ExpressionElement[] {
  return Expressions.everything(concat)((expr: Expression) => {
    const element = Expressions.getElement(expr);
    if (
      element &&
      getPluginName(element.type) === '__SitePlugin' &&
      componentMap.has(element.type)
    ) {
      return Expressions.resume([element]);
    }
    return Expressions.resume(emptyArray);
  });
}
